export const CREATE_PARKING_RATE = 'CREATE_PARKING_RATE';
export const EDIT_PARKING_RATE = 'EDIT_PARKING_RATE';
export const SHOW_PARKING_RATE = 'SHOW_PARKING_RATE';
export const PARKING_RATE_SUCCESS = 'PARKING_RATE_SUCCESS';
export const PARKING_RATE_ERROR = 'PARKING_RATE_ERROR';

